export enum EFeedbackToSlackStatus {
  WAITING = 'waiting',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  ERROR = 'error'
}
